import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AppConfig } from './../../app.config';
@Injectable()
export class ResetPasswordService {
    private urlSignIn4ResetPwd: string;
    private urlResetPwdByUser: string;

    constructor(private _http: HttpClient, private _appConfig: AppConfig) {
        this.urlSignIn4ResetPwd = _appConfig.getConfig().nPointAuthService + '/auth/signin_resetpwd';
        this.urlResetPwdByUser = _appConfig.getConfig().nPointAuthService + '/auth/pwdreset';
    }

    signIn4ResetPwd(p_Origin: string): Observable<any> {
        const l_Data = { token: p_Origin };
        return this._http.post(this.urlSignIn4ResetPwd, l_Data);
    }


    resetPwdByUser(p_Pass: string): Observable<any> {
        const l_Data = { newPwd: p_Pass};
        return this._http.post(this.urlResetPwdByUser, l_Data);
    }

    public CheckPasswordPattern(p_password: string, p_pattern: string): boolean {
        switch (p_pattern) {
            case 'length': {
                return !(p_password.length < 8);
            }
            case 'majuscule': {
                return !(!/[A-Z]/.test(p_password));
            }
            case 'minuscule': {
                return !(!/[a-z]/.test(p_password));
            }
            case 'numerique': {
                return !(!/\d/.test(p_password));
            }
            case 'specialCar': {
                return !(!/[@$^&+="]/.test(p_password));
            }

        }
        return false;
    }

}



// WEBPACK FOOTER //
// ./src/app/services/login/reset-password.ts